import { readRawPref, STORAGE_PREFIX, writeRawPref } from '@/app/lib/paneKeys'

/** How many bars of a run's chart.json the Chart tab may ask for (spec 037 D-14). */
export const BARS_OPTIONS = [1000, 2500, 5000, 10000, 25000, 50000, 100000] as const
export const DEFAULT_BARS = 10000
export const QUANT_CHART_BARS_KEY = `${STORAGE_PREFIX}quant-chart-bars`

function readMap(): Record<string, unknown> {
  const raw = readRawPref(QUANT_CHART_BARS_KEY)
  if (raw === null) return {}
  try {
    const parsed: unknown = JSON.parse(raw)
    if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) return parsed as Record<string, unknown>
  } catch {
    // corrupt JSON falls through to an empty map
  }
  return {}
}

function isAllowed(value: unknown): value is number {
  return typeof value === 'number' && (BARS_OPTIONS as readonly number[]).includes(value)
}

/** The stored bar count for one strategy, or the default for anything missing or invalid. Never writes. */
export function readChartBars(slug: string): number {
  const value = readMap()[slug]
  return isAllowed(value) ? value : DEFAULT_BARS
}

/** Remember a strategy's bar count, keeping every other strategy's valid entry. */
export function writeChartBars(slug: string, bars: number): void {
  if (!isAllowed(bars)) return
  const next: Record<string, number> = {}
  for (const [key, value] of Object.entries(readMap())) {
    if (isAllowed(value)) next[key] = value
  }
  next[slug] = bars
  writeRawPref(QUANT_CHART_BARS_KEY, JSON.stringify(next))
}
